<sim-basic-material-dialog
	(closeClicked)="close({action: 'close'})"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
	class="normalDuotoneHeaderIcon"
>
	<div dialogContent>
		<div class="top">
			<div class="removeIcon">
				<i class="fad fa-file-check"></i>
			</div>
			<div class="innerContent">
				<div class="title mat-h2 nomargin">{{ data.title }}</div>
			</div>
		</div>
		<div class="bottom">
			<div class="text mat-h2 nomargin" [innerHtml]="data.description"></div>
		</div>
	</div>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'cancel'})"
			[icon]="{fontSet: 'fal', fontIcon: 'fa-times'}"
			[label]="data.cancelText.toUpperCase()"
			[color]="'warn'"
		/>

		<sim-button
			(onClick)="close({action: 'ok'})"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="data.okText.toUpperCase()"
			[color]="'accent'"
		/>

		<sim-button
			(onClick)="close({action: 'replaceAll'})"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="data.replaceAllText.toUpperCase()"
			[color]="'accent'"
		/>
	</ng-container>
</sim-basic-material-dialog>
